import {

    SyncOutlined,
  
  } from "@ant-design/icons";
  import {
    Row,
    Col,
    Typography,
    
    Select,
   
    Button,
    Space,
    Form,
    Table,
   
    Flex,
  } from "antd";
  import { useEffect, useState } from "react";
  import "../Pages/CSS/Traitement.css";
  import * as XLSX from "xlsx";
  import { JournalCentralService } from "../Services/JournalCentralService";
  
  import { RembousementsService } from "../Services/RemboursementsService";
  import dayjs from "dayjs";
  import { SuspensionsService } from "../Services/SuspensionsService";
import { TraitementService } from "../Services/TraitementService";
  const { Title } = Typography;
  const { Option } = Select;
  
  const Hospitalisations = () => {
    const getSelectedYear = () => {
      const currentYear = new Date().getFullYear();
      return currentYear.toString();
    };
    const initialTableData = [];
    const [tableData, setTableData] = useState(initialTableData);
    const [filteredData, setFilteredData] = useState(initialTableData);
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState("01");
    const [years, setYears] = useState([]);
    const [paramData, setParamData] = useState([])
    const [totalAmount, setTotalAmount] = useState(0);
    const [rowCount, setRowCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);
  
    const [form] = Form.useForm();
  
    const journalCentralService = new JournalCentralService();
    const suspensionsService = new SuspensionsService();
    const traitementsoinsService = new TraitementService();

    const fetchDataInit = async () => {
               const getParam = await traitementsoinsService.getParamComptable();
               setParamData(getParam);
               const yearFromParamData = dayjs(getParam.datedeb).format("YYYY");
                    setSelectedYear(yearFromParamData)
             };
           
             useEffect(() => {
              
               fetchDataInit();
               return () => {};
             }, []);
  
    const fetchData = async () => {
      try {
        const yearsData = await journalCentralService.getComptaExercices();
        console.log("Années récupérées :", yearsData); // Vérifiez la structure des données
        setYears(yearsData);
  
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };
  
    useEffect(() => {
      fetchData();
    }, []);
    
    useEffect(() => {
    const fetchData1 = async () => {
      if (selectedYear ) {
          setLoading(true);
        try {
          const data = await suspensionsService.getSuspensionsHospis(selectedYear);
          // Filtrer ici si nécessaire, ou s'assurer que le service API renvoie déjà les données filtrées
          setTableData(data);
          setFilteredData(data);
          
        } catch (error) {
          console.error("Erreur lors de la récupération des données :", error);
        }finally {
          setLoading(false);
        }
      }
    };
    
   
      fetchData1();
    }, [selectedYear]); 
  
    useEffect(() => {
      const total = filteredData.reduce(
        (acc, curr) => acc + parseFloat(curr.montfact || 0),
        0
      );
      setTotalAmount(total);
      setRowCount(filteredData.length);
    }, [filteredData]);
  
    const handleYearChange = (value) => {
      setSelectedYear(value);
    };

    const handleRefresh = async () => {
      setLoading(true);
      try {
        if (selectedYear) {
          const data = await suspensionsService.getSuspensionsHospis(selectedYear);
          setTableData(data);
          setFilteredData(data);
        }
      } catch (error) {
        console.error("Erreur lors de l'actualisation des données :", error);
      } finally {
        setLoading(false);
      }
    };
    
  
  /* 
    const columns = [
      { title: 'Matricule', dataIndex: 'numcont', key: 'numcont' ,   align: "center",},
      { title: 'Participant', dataIndex: 'part', key: 'part' },
      { title: 'Sexe', dataIndex: 'sexe', key: 'sexe' ,   align: "center", },
      { title: 'Société', dataIndex: 'societe', key: 'societe' },
      { title: 'Âge', dataIndex: 'agepart', key: 'agepart' ,   align: "center", },
      { title: 'N° téléphone', dataIndex: 'portable', key: 'portable' },
      { title: 'Consommation', dataIndex: 'conso', key: 'conso', align: "right", },
    ]; */

    const columns = [
      {
        title: 'Matricule',
        dataIndex: 'numcont',
        key: 'numcont',
        align: "center",
        sorter: (a, b) => {
          if (!a.numcont && b.numcont) return 1;
          if (a.numcont && !b.numcont) return -1;
          if (!a.numcont && !b.numcont) return 0;
          return a.numcont.localeCompare(b.numcont);
        },
      },
      {
        title: 'Participant',
        dataIndex: 'part',
        key: 'part',
        sorter: (a, b) => {
          if (!a.part && b.part) return 1;
          if (a.part && !b.part) return -1;
          if (!a.part && !b.part) return 0;
          return a.part.localeCompare(b.part);
        },
      },
      {
        title: 'Sexe',
        dataIndex: 'sexe',
        key: 'sexe',
        align: "center",
        sorter: (a, b) => {
          if (!a.sexe && b.sexe) return 1;
          if (a.sexe && !b.sexe) return -1;
          if (!a.sexe && !b.sexe) return 0;
          return a.sexe.localeCompare(b.sexe);
        },
      },
      {
        title: 'Société',
        dataIndex: 'societe',
        key: 'societe',
        sorter: (a, b) => {
          if (!a.societe && b.societe) return 1;
          if (a.societe && !b.societe) return -1;
          if (!a.societe && !b.societe) return 0;
          return a.societe.localeCompare(b.societe);
        },
      },
      {
        title: 'Âge',
        dataIndex: 'agepart',
        key: 'agepart',
        align: "center",
        sorter: (a, b) => (a.agepart ?? 0) - (b.agepart ?? 0),
      },
      {
        title: 'N° téléphone',
        dataIndex: 'portable',
        key: 'portable',
        sorter: (a, b) => {
          if (!a.portable && b.portable) return 1;
          if (a.portable && !b.portable) return -1;
          if (!a.portable && !b.portable) return 0;
          return a.portable.localeCompare(b.portable);
        },
      },
      {
        title: 'Consommation',
        dataIndex: 'conso',
        key: 'conso',
        align: "right",
        sorter: (a, b) => (a.conso ?? 0) - (b.conso ?? 0),
        render: (text) => (
          <div style={{ paddingRight: 10 }}>
            <strong>
            {text && parseFloat(text) !== 0 ? parseFloat(text).toLocaleString() : ""}
            </strong>
          </div>
        ),
      },
    ];
    const exportToExcel = (data, fileName = "export.xlsx") => {
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
        XLSX.writeFile(workbook, fileName);
      };
    
    
  
    const isTableEmpty = filteredData.length === 0;
  
  
    return (
      <div>
      
        <Row gutter={16} style={{marginBottom: 16 }}>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={8}
            style={{ display: "flex", justifyContent: "start"}}
          >
            <Space wrap>
              <Space
                direction="vertical"
                style={{ marginRight: 12, textAlign: "left" }}
              >
                <label>Exercice</label>
                <Select
                  bordered={false}
                  style={{ borderBottom: "2px solid #030303", width: "100%" }}
                  onChange={handleYearChange}
                  value={selectedYear}
                >
                  {years.map((year) => (
                    <Option key={year} value={year}>
                      {year}
                    </Option>
                  ))}
                </Select>
              </Space>
            
            </Space>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={16}
            style={{ display: "flex", justifyContent: "end", alignItems: "end" }}
          >
            <Flex wrap="wrap" gap="small">
            <Button className="buttonExport" disabled={isTableEmpty}  onClick={() => exportToExcel(filteredData)}
            >
                Export Excel
              </Button>
              <Button 
  icon={<SyncOutlined />} 
  className="buttonRefresh" 
  onClick={handleRefresh} 
  loading={loading} 
>
  Actualiser
</Button>

            </Flex>
          </Col>
        </Row>
  
       
        <Table
        scroll={{ x: true }}
        style={{
          cursor: "pointer",
          whiteSpace: "nowrap",
          width: "100%",
        }}
        className="custom-header2-table"
        bordered
        columns={columns}
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
          showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
          pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
          onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
        }}
        showSorterTooltip={false}
        dataSource={filteredData}
        loading={loading}
        rowKey={record => record.numdoc} 
      />
      
      </div>
    );
  };
  
  export default Hospitalisations;
  